import { OutletModel, PaymentsModel } from '@pukka/api';

function getStatusCount(outlets?: OutletModel.Outlet[], outletStatuses?: PaymentsModel.OutletStatuses) {
  let activeCount = 0;
  let pendingCount = 0;
  let rejectedCount = 0;
  let inactiveCount = 0;

  outlets?.forEach((outlet) => {
    const status = outletStatuses?.[outlet.id];

    switch (status) {
      case 'APPROVED':
        activeCount += 1;
        break;
      case 'PENDING':
        pendingCount += 1;
        break;
      case 'REJECTED':
        rejectedCount += 1;
        break;
      default:
        inactiveCount += 1;
        break;
    }
  });

  return {
    active: activeCount,
    pending: pendingCount,
    rejected: rejectedCount,
    inactive: inactiveCount,
  };
}

function getInactiveOutlets(outlets?: OutletModel.Outlet[], outletStatuses?: PaymentsModel.OutletStatuses) {
  return outlets?.filter((outlet) => {
    const status = outletStatuses?.[outlet.id];
    const isInactive = status !== 'APPROVED' && status !== 'PENDING' && status !== 'REJECTED';

    return isInactive;
  });
}

function combineOutletNameAndStatus(outlets?: OutletModel.Outlet[], outletStatuses?: PaymentsModel.OutletStatuses) {
  return outlets?.map((outlet) => ({
    name: outlet.name,
    status: outletStatuses?.[outlet.id] || 'INACTIVE',
  }));
}

export { getStatusCount, getInactiveOutlets, combineOutletNameAndStatus };
